"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NeverLogApi = require("./NeverLogApi");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: 'NEVER_LOG',
  fetch: function fetch() {
    return (0, _NeverLogApi.fetchLoggingBlacklist)();
  }
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: 'NEVER_LOG',
  idIsValid: function idIsValid(id) {
    return id === 'neverlogList';
  }
}).defineName('NeverLogStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;